module.exports = {
    LAN: {
        change_pwd: 'chang pwd' 
    }
}